import { useQuery } from '@tanstack/react-query';
import { RankGroupsQueryKeys } from '../../queryKeys';
import { fetchRankGroups } from './service';
import { PaginatedResponse } from '@/models/pagination/paginated-response.dto';
import { RankGroup } from '@/models/rank/group';
import { AxiosError } from 'axios';
import { GenericError } from '@/models/generic-error';

export function useRankGroups() {
  const queryKey = [RankGroupsQueryKeys.Primary];

  const { data, isPending, error, refetch } = useQuery<
    PaginatedResponse<RankGroup>,
    AxiosError<GenericError>
  >({ queryKey, queryFn: fetchRankGroups });

  return {
    rankGroups: data,
    isLoading: isPending,
    error,
    refetch,
  };
}
